import { render, staticRenderFns } from "./syncEquipmentStandardSetting.vue?vue&type=template&id=48314a86&scoped=true"
import script from "./syncEquipmentStandardSetting.vue?vue&type=script&lang=js"
export * from "./syncEquipmentStandardSetting.vue?vue&type=script&lang=js"
import style0 from "./syncEquipmentStandardSetting.vue?vue&type=style&index=0&id=48314a86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48314a86",
  null
  
)

export default component.exports